export default __webpack_public_path__ + "static/media/info08_Acude_a_la_JDE.7fc45780.png";